import { render, staticRenderFns } from "./ToolbarAccount.vue?vue&type=template&id=338eb647&"
import script from "./ToolbarAccount.vue?vue&type=script&lang=js&"
export * from "./ToolbarAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
installComponents(component, {VAvatar,VBtn,VIcon,VImg})
